import * as React from "react";
import {IReadReportResponse} from "../../core/api/report/response/IReadReportResponse";

interface IProps {
    data: IReadReportResponse;
}

interface IState {
    menuItem: {}
}

export class SocietyReportGridItem extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            menuItem: {}
        }
    }

    public render() {
        return (
            <div className="blog-item">
                <div className="pull-right">
                    <a className="btn btn-mod btn-round btn-small" href={'/aspirasi-pengaduan/' + this.props.data.slug}>Detail</a>
                </div>
                <div className="blog-item-date">
                    <span className="date-num">{this.props.data.date}</span>{this.props.data.month}
                </div>
                <h2 className="blog-item-title font-alt">
                    <a href={'/aspirasi-pengaduan/' + this.props.data.slug}>{this.props.data.title}</a>
                </h2>
                <div className="blog-item-data">
                    {this.props.data.category} | {this.props.data.statusDescription}
                </div>
                {this.props.data.image !== undefined && this.props.data.image !== null ? (
                    <div className="blog-media">
                        <a href={'/aspirasi-pengaduan/' + this.props.data.slug}>
                            <img src={this.props.data.image} className="img-medium" />
                        </a>
                    </div>
                ): <span/>}

                <div className="blog-item-body">
                    <p>{this.props.data.shortDescription}</p>
                </div>
                <hr/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/society-report/SocietyReportGridItem.tsx